import { useUploader } from "contexts/uploaderContext/uploaderContext.js";

const useFileProgress = (file, progress) => {
  const { getIsUppy } = useUploader();

  const isComplete = getIsUppy()
    ? file.progress.uploadComplete
    : progress === file.size;

  const isError = getIsUppy() ? file.meta.error : progress === "error";

  const persentegeProgress = getIsUppy()
    ? file.progress.percentage
    : progress > 0
    ? Math.round((progress / file.size) * 100)
    : 0;

  return {
    isComplete,
    isError,
    persentegeProgress,
  };
};

export default useFileProgress;
